// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-Oeo0q";
var _4 = "content-lFREL";
var _5 = "content_loading-14FH0";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "content", _5 as "content_loading" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "content": _4, "content_loading": _5 }
